import React from 'react'
import axios from 'axios'
import ruta from '../routes/api-routes'
import Navegador from '../components/Navegador'
import Detalles from '../components/Detalles'

class DetalleCarro extends React.Component {
    state = {
        form: {
            brand: '',
            model: '',
            year: '2019',
            price: '',
            color: '',
            km: '0',
            transmission: 'Manual', 
            doors: '4', 
            gas: 'Normal', 
            fuelCap: '',
            engine: '', 
            horsepower: '',
            descrip: '',
            picturePath: '',
            used: false
        },
        error: "",
        carId: ''
    }
  
    // Get data from the API endpoint to show information
    async componentDidMount(){
        // If there is a parameter, this make the request
        if(this.props.match.params.id) {
            try {
                const idCarro = this.props.match.params.id
                const res = await axios.get(ruta.editarCarro+idCarro)
                this.setState({
                    carId: this.props.match.params.id,
                    form: res.data
                })
                console.log(res.data)
            } catch (error) {
                console.log(error)
            }
            
        }
    }

    // Handle change works when a key is pressed on the form
    handleChange = e => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        })
    }

    // This just prevent submit button actions
    handleSubmit = async e => {
        e.preventDefault()
    }

    render(){
        return (
            <React.Fragment>
                <Navegador/>
                <Detalles
                form={this.state.form}
                />
            </React.Fragment>
        )
    }
}

export default DetalleCarro